import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { formatErrors } from '@effect/schema/TreeFormatter';
import { BlockWidthWrapper } from '@infl-ts/util-block-width-context';
import { Warning as WarningIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { stripIndent } from 'common-tags';
import { absurd, pipe } from 'fp-ts/function';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var resolveBlocksComponent = function resolveBlocksComponent(blocks, name) {
  var blocks_ = pipe(blocks);
  return Object.assign(function (props) {
    if (!(props.block.typename in blocks_)) return /*#__PURE__*/_jsx(ReportMissingBlock, _objectSpread(_objectSpread({}, props), {}, {
      errorType: "not-implemented"
    }));
    var Comp = blocks_[props.block.typename]["default"];
    if (!Comp) return /*#__PURE__*/_jsx(ReportMissingBlock, _objectSpread(_objectSpread({}, props), {}, {
      errorType: "missing-default-export"
    }));
    return /*#__PURE__*/_jsx(Comp, _objectSpread({}, props));
  }, {
    displayName: name
  });
};
export function ReportMissingBlock(props) {
  if (true) return null;

  if (props.errorType === 'missing-matching-schema') {
    var _console;

    // eslint-disable-next-line no-console
    console.error('Missing block was called with these props:', props); // eslint-disable-next-line no-console

    (_console = console).error.apply(_console, ['Validation errors:'].concat(_toConsumableArray(formatErrors(props.parseError.errors))));

    return /*#__PURE__*/_jsx(BlockWidthWrapper, {
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          backgroundColor: function backgroundColor(t) {
            return t.palette.warning.light;
          },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        },
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "h3",
          sx: {
            display: 'flex',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsx(WarningIcon, {
            sx: {
              mr: 2
            }
          }), props.errorType === 'missing-matching-schema' ? stripIndent(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                  Received block data, but was not able to \n                  successfully validate against any of the existing codecs.\n                "]))) : absurd(props)]
        }), /*#__PURE__*/_jsx(Typography, {
          children: " Check browser console for more info"
        })]
      })
    });
  }

  if (props.errorType === 'missing-default-export') throw new Error("\"".concat(props.block.typename, "\" module is missing default export"));
  return /*#__PURE__*/_jsx(BlockWidthWrapper, {
    "data-element": "BlockWidthWrapper",
    "data-component": "ReportMissingBlock",
    "data-source-file": "resolve-blocks.tsx",
    children: /*#__PURE__*/_jsxs(Typography, {
      sx: {
        textAlign: 'center'
      },
      "data-element": "Typography",
      "data-component": "ReportMissingBlock",
      "data-source-file": "resolve-blocks.tsx",
      children: ["No component for typename ", /*#__PURE__*/_jsx("code", {
        "data-component": "ReportMissingBlock",
        "data-source-file": "resolve-blocks.tsx",
        children: props.block.typename
      })]
    })
  });
}